import faker from 'faker';
import { Factory } from 'rosie';

import { IAutoCoverageValues, ICoverageConfig } from '../../../interfaces';

import { allCoverageDetails } from './coverageDetails';
import { getRegionConfig } from './helpers';

function buildCoverageValuesObject(coverageConfigs: ICoverageConfig[]) {
  return coverageConfigs.reduce(
    (acc, coverage) => ({
      ...acc,
      [coverage.key]:
        coverage.value_type === 'boolean'
          ? faker.datatype.boolean()
          : allCoverageDetails?.[coverage.key]?.values.filter(Boolean)[0],
    }),
    {}
  );
}

export const AutoAllCoverages = new Factory<IAutoCoverageValues>()
  .option('regionCode', null)
  .after((_, { regionCode } = {}) => {
    const coveragesConfigs = getRegionConfig(regionCode)?.coverages || [];
    return buildCoverageValuesObject(coveragesConfigs);
  });

export const AutoPolicyCoverages = new Factory<IAutoCoverageValues>()
  .option('regionCode', null)
  .after((_, { regionCode } = {}) => {
    const coveragesConfigs = getRegionConfig(regionCode)?.coverages || [];
    const filteredCoverages = coveragesConfigs.filter(
      (coverages) => coverages.appliesTo === 'POLICY'
    );
    return buildCoverageValuesObject(filteredCoverages);
  });

export const AutoVehicleCoverages = new Factory<IAutoCoverageValues>()
  .option('regionCode', null)
  .after((_, { regionCode } = {}) => {
    const coveragesConfigs = getRegionConfig(regionCode)?.coverages || [];
    const filteredCoverages = coveragesConfigs.filter(
      (coverages) => coverages.appliesTo === 'VEHICLE'
    );
    return buildCoverageValuesObject(filteredCoverages);
  });
